<template>

  <v-dialog
    v-model="show"
    persistent
    max-width="970">
    <v-card>
        <v-toolbar class="mid-font" color="primary" dense dark >
            <v-icon left >mdi-account-box</v-icon><span class="va-underline">{{state=='new'?'New':'Update'}} Billing</span>
            <v-spacer/>
            <v-icon  @click="emitToParent('close')">mdi-close</v-icon>
          </v-toolbar>
        <v-card-text>
             
              <v-row>
                <v-col cols="6">
                  <v-form
                ref="form"
                
                v-model="valid"
                lazy-validation
              >
                  <div class="text-h6">Account Information</div>
                  <v-divider/>
                      <v-col cols="12">
                        <v-text-field
                      outlined
                        dense
                      v-model="billing.account"
                        label="Account No." 
                        :rules="textRules"
                      required
                      ></v-text-field>
                      <v-text-field
                      outlined
                        dense
                      v-model="billing.name"
                        label="Account Name"
                        :rules="textRules"
                      required
                      ></v-text-field>
                      <v-text-field
                      outlined
                        dense
                      v-model="billing.area"
                        label="Area"
                      ></v-text-field>
                        <v-text-field
                      outlined
                        dense
                      v-model="billing.branch"
                        label="Branch"
                      ></v-text-field>
                    <!-- <v-text-field
                      v-model="billing.reference"
                        label="Reference ID"
                        outlined
                        dense
                        :rules="textRules"
                      required
                      ></v-text-field> -->
                      <v-text-field
                      v-model="billing.mobile_no"
                        label="Mobile No."
                        outlined
                        dense
                        :rules="textRules"
                      required
                      ></v-text-field>
                      <v-text-field
                      outlined
                        dense
                      v-model="billing.email"
                        label="Email"
                        :rules="textRules"
                      required
                      ></v-text-field>
                      <!-- <v-autocomplete
                        v-model="billing.status"
                        :rules="textRules"
                      required
                        :items="ROLES"
                        outlined
                          dense
                        label="Status  "
                        ></v-autocomplete>  -->
                        <v-text-field
                      outlined
                        dense
                      v-model="billing.remarks"
                        label="Remarks"
                      ></v-text-field>
                      </v-col>
                    </v-form>
                  </v-col>
                  <v-col cols="6">
                    <div class="text-h6">Items</div>
                  <v-divider/>
                  <v-row>
                    <v-col cols="6">
                      <v-text-field
                      outlined
                        dense
                      v-model="item.name"
                        label="Name"
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                      outlined
                        dense
                      v-model="item.amount"
                        label="Amount"
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                      outlined
                        dense
                      v-model="item.description"
                        label="Description"
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" class="text-right" style="height: 50px;">
                      <v-btn small color="primary" v-if="CANADD" @click="Add()">Add Item</v-btn>
                    </v-col>
                  </v-row>
                  <v-divider/>
                    <v-row>
                        <v-col cols="12">
                            <table class="va-table va-table-border-bot">
                                <tr v-for="(item, index) in items" :key="index">
                                  <td>
                                    <v-icon left v-if="CANREMOVE" color="error" @click="RemoveItem(index)">mdi-close</v-icon>
                                    <span class="font-weight-bold">{{item.name}}</span>
                                    <br/>
                                    <span class="font-italic">{{item.description}}</span>
                                  </td>
                                  <td class="text-right">
                                    <span class="font-weight-bold">{{$money($IsNum(item.amount))}}</span>
                                  
                                  </td>
                                </tr>
                                
                                <tr>
                                  <td class="text-h5 pt-5">
                                    TOTAL BILLING:
                                  </td>
                                  <td colspan="2" class="text-right text-h5 pt-5">
                                     <span class="font-weight-bold text-primary">{{$money(TOTAL)}}</span>
                                  </td>
                                </tr>
                            </table>
                        </v-col>
                    </v-row>
                  </v-col>     
              </v-row>
            
        </v-card-text>
        <v-card-actions>
                <v-btn color="warning" small rounded text @click="emitToParent('close')">CLOSE</v-btn>
            <v-spacer></v-spacer>
            <v-btn  small color="success"  depressed  @click="validate()" >{{BTN_TEXT}}</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: {
        type: Boolean,
        default: false
    },
    selectedID: {
       type: Number,
        default: null
    },
    state: {
        type: String,
        default: "new"
    }
  },
  data: () => ({
      valid: true,
      newpassword:'',
      show1: false,
      billing: {},
      item: {},
      items: [],
      textRules: [
        v => !!v || 'Field is required'
      ],
  }),
  computed: {
      BTN_TEXT() {
          if(this.state == 'new')
            return "ADD"
         else 
            return "SAVE"
      },
      CANREMOVE() {
          if(this.state == 'new')
            return  true
         else 
            return false
      },
      TOTAL(){
        var total = 0
        if(this.items.length != 0) {
          total = this.items.reduce((res,i)=>{
             
            return res + this.$IsNum(i.amount)
          }, 0)
        } 
        return  total
      },
      CANADD(){
        if(!this.item.name) {
          return false
        } else if(!this.item.amount) {
          return false
        } else if(!this.item.description) {
          return false
        }
        return true
      },
      ROLES() {
        return ['Created', 'Pending', "Paid"]
      }
  },
  watch: {
    show (v) {
      if (v) {
        this.item = {}
        this.items = []
         if(this.state != 'new') { this.getItem() }
      } 
    }
  },
  methods: {
      validate () {
        if (this.$refs.form.validate()) {
            this.state=='new'?this.NewBilling():this.Update()
        }
      },
      RemoveItem(index) {
        this.items.splice(index,1)
      },
       Add: function() {
        //console.log(this.item)
         this.items.push(this.item)
         setTimeout(()=>{
          this.item = {}
         },800 )
        // this.item = {}
        // var param = {}
        // var entries = Object.entries(this.item)
        // for (const [keyname, value] of entries) {
        //   param[keyname] = this.$Filter(value)
        // }
        // console.log(param)
        // this.$http.post("franchisee/new", param).then(response => {
        //     response.data.status? this.VA_ALERT('success', response.data.message) : this.VA_ALERT('error', response.data.message) 
        //     this.$emit('DialogEvent', "")
        // }).catch(e => {
        //   console.log(e)
        // })
     },
     NewBilling: function() {
       this.billing.amount = this.TOTAL.toString()
       console.log(this.billing)
       this.$http.post("billing/new", this.billing).then(response => {
           response.data.status? this.VA_ALERT('success', response.data.message) : this.VA_ALERT('error', response.data.message) 
           this.$emit('DialogEvent', "")
       }).catch(e => {
         console.log(e)
       })
    },
      Update: function() {
       
        this.$http.post("franchisee/update", this.item).then(response => {
            response.data.status? this.VA_ALERT('success', response.data.message) : this.VA_ALERT('error', response.data.message) 
            this.$emit('DialogEvent', "")
        }).catch(e => {
          console.log(e)
        })
     },
     getItem: function() {
        this.$http.post("franchisee/get", {id:this.selectedID}).then(response => {
            response.data.status? this.item = response.data.item : this.item = {}
           console.log(this.item)
        }).catch(e => {
          console.log(e)
        })
     },
    emitToParent () {
        this.$emit('DialogEvent', "")
    }
  }
}
</script>
